import TitlePage from '../../components/TitlePage';
import H1Styled from '../../components/Typography/H1Styled';
import FiltersBar from '../../components/Filters/FiltersBar';
import Pagination from '../../components/Pagination';
import DocentiTable from './Tables/DocentiTable';
import { useAuth } from '../../contexts/Auth';
import { useSearchParams } from 'react-router-dom';
import { useDebounce } from 'use-debounce';
import { useMemo } from 'react';
import { useQuery } from 'react-query';
import { FilterType } from '../../interfaces/filters';
import { getGroupFilter } from '../../libs/utils/helpers';
import { getTeachers } from '../../api/profile';
import { regions } from '../../api/regions';
import { provinces } from '../../api/provinces';
import sectionsAPIs from '../../api/section';
import { findOptions as lessonTemplatesFindOptions } from '../../api/lesson-template';
import { levels } from '../../constants/levels';

const ListaDocenti = () => {
  const [searchParams] = useSearchParams();
  const [{ token }] = useAuth();
  const { REACT_APP_DEBOUNCE_DELAY } = process.env;
  const delay = Number(REACT_APP_DEBOUNCE_DELAY);
  const [debounceSearchParams] = useDebounce(searchParams, delay);

  const teachersListQuery = useQuery(
    ['teachersList', ...debounceSearchParams],
    () => {
      const query = {
        filters: {
          regions: getGroupFilter({ filterName: 'regions', searchParams }),
          provinces: getGroupFilter({ filterName: 'provinces', searchParams }),
          sections: getGroupFilter({ filterName: 'sections', searchParams }),
          courses: getGroupFilter({ filterName: 'courses', searchParams }),
          lessons: getGroupFilter({ filterName: 'lessons', searchParams }),
          search: searchParams.get('search') || undefined,
        },
        pagination: {
          page: searchParams.get('page'),
          pageSize: searchParams.get('pageSize'),
        },
      };

      return getTeachers({
        token,
        query,
      });
    }
  );

  const filterBar = useMemo(
    () => [
      {
        type: FilterType.MULTISELECT,
        attribute: 'regions',
        label: 'Regione',
        key: 'teachersRegionsFilter',
        source: regions,
        searchForAttributes: ['name'],
      },
      {
        type: FilterType.MULTISELECT,
        attribute: 'provinces',
        label: 'Provincia',
        key: 'teachersProvincesFilter',
        source: provinces,
        searchForAttributes: ['name', 'code'],
      },
      {
        type: FilterType.MULTISELECT,
        attribute: 'sections',
        label: 'Sezione',
        key: 'teachersSectionsFilter',
        source: (data: any) =>
          sectionsAPIs.findOptions({
            ...data,
            query: { ...data.query },
          }),
        searchForAttributes: ['name'],
      },
      {
        type: FilterType.MULTISELECT,
        attribute: 'courses',
        label: 'Corso',
        key: 'teachersCoursesFilter',
        source: () => ({
          data: levels.map((level) => ({
            id: level.value,
            attributes: { name: level.label },
          })),
        }),
        isSearchable: false,
      },
      {
        type: FilterType.MULTISELECT,
        attribute: 'lessons',
        label: 'Lezione',
        key: 'teachersLessonsFilter',
        source: lessonTemplatesFindOptions,
        searchForAttributes: ['title'],
      },
      {
        type: FilterType.SEARCH_BAR,
        attribute: 'search',
        label: 'Cerca...',
      },
    ],
    []
  );

  return (
    <>
      <TitlePage title='Docenti' />

      <H1Styled>Docenti</H1Styled>

      <div className='space-y-5'>
        <FiltersBar filters={filterBar} />
        <DocentiTable query={teachersListQuery} />
        <Pagination
          pagination={teachersListQuery.data?.meta.pagination}
          defaultPageSize={20}
        />
      </div>
    </>
  );
};

export default ListaDocenti;
